export default "__VITE_ASSET__C2N5YYQw__"